var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.2598 35.2002V75.5641L45.9274 53.0085L23.2598 35.2002Z",
    fill: "#73151F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5473 59.7066C56.24 59.9481 55.87 60.0694 55.5 60.0694C55.13 60.0694 54.76 59.9492 54.4527 59.7066L48.6139 55.1196L25.6636 77.9558H85.3363L62.3861 55.1196L56.5473 59.7066Z",
    fill: "#73151F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.7404 75.5641V35.2002L65.0728 53.0085L87.7404 75.5641Z",
    fill: "#73151F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9952 33.043H26.0049L55.5 56.2163L84.9952 33.043Z",
    fill: "#73151F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail1);
export default __webpack_public_path__ + "static/media/email1.2bc301c4ece1e320f2585330468cdf41.svg";
export { ForwardRef as ReactComponent };